import _ from 'underscore';
import EverTrue from 'app';
import ListIndexTable from '../components/index/list-index-table';
import FoldersCard from 'apps/folder/components/detail/folders-card';
import ListIndexActions from 'apps/lists/components/index/list-index-actions';
import CommonDeleteModal from 'apps/folder/components/modal/common-delete-modal';
import BulkListController from 'apps/lists/controllers/bulk-list-controller';
import RecentlyViewedLists from 'apps/lists/components/index/recently-viewed-lists';
import { useLists } from '../hooks/use-lists';
import { PageHeader, useOpenClose } from '@evertrue/et-components';
import { useEffect, useRef } from 'react';

const ListIndexController = () => {
  const folderCardRef = useRef();

  // Modals State
  const [isCreateModalOpen, openCreateModal, closeCreateModal] = useOpenClose();
  const [bulkDeleteModalOpen, openBulkDeleteModal, closeBulkDeleteModal] = useOpenClose();

  // Fetch Lists
  const ownedOnly = false; // in the future, it would be nice to add a toggle to the toolbar for this, as a quick filter
  const {
    total,
    lists,
    getLists,
    loading,
    deleteList,
    deleteLists,
    search,
    handleSearchChange,
    sortModel,
    handleSortChange,
    paginationModel,
    setPaginationModel,
    rowSelectionModel,
    updateRowSelectionModel,
    clearSelections,
    enableAllActions,
  } = useLists('static', ownedOnly);

  const handleBulkDelete = () => {
    deleteLists(Array.from(rowSelectionModel.ids));
    clearSelections();
    closeBulkDeleteModal();
  };

  /*
  If a user navigates to the lists page from Clarity, immediately open the add list modal
  */
  const fromClarity = EverTrue.UrlManager.get('fromClarity');
  const listName = EverTrue.UrlManager.get('name');
  useEffect(() => {
    if (fromClarity) {
      openCreateModal();
    }
  }, [fromClarity, openCreateModal]);

  return (
    <>
      <PageHeader
        title="Your Lists"
        actions={
          <ListIndexActions
            enableAllActions={enableAllActions}
            openCreateModal={openCreateModal}
            openBulkDeleteModal={openBulkDeleteModal}
            folderCardRef={folderCardRef}
            anyListSelected={rowSelectionModel.ids.size > 0}
          />
        }
      />
      <div className="lists-page-controller">
        {/* Main Table */}
        <div style={{ height: 'calc(100vh - 133px)', flex: 1 }}>
          <ListIndexTable
            tableKey="list-index-table"
            lists={lists}
            total={total}
            loading={loading}
            deleteList={deleteList}
            search={search}
            onSearchChange={handleSearchChange}
            sortModel={sortModel}
            setSortModel={handleSortChange}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            rowSelectionModel={rowSelectionModel}
            updateRowSelectionModel={updateRowSelectionModel}
          />
        </div>

        {/* Side Bar */}
        <div style={{ flex: 0.5 }}>
          <FoldersCard
            ref={folderCardRef}
            listIds={Array.from(rowSelectionModel.ids)}
            clearSelections={clearSelections}
          />
          <RecentlyViewedLists lists={lists} />
        </div>
      </div>
      {/* Create List Modal */}
      {isCreateModalOpen && (
        <BulkListController
          listName={listName}
          fromClarity={fromClarity}
          remove={() => {
            EverTrue.UrlManager.unset('fromClarity');
            EverTrue.UrlManager.unset('name');
            closeCreateModal();
          }}
          onComplete={() => _.delay(getLists, 2000)} // This is frustrating but we have no way to retrieve the newly-created list from the BulkListController modal, so we have to refetch the whole table.
        />
      )}
      <CommonDeleteModal
        isOpen={bulkDeleteModalOpen}
        onClose={closeBulkDeleteModal}
        handleDelete={handleBulkDelete}
        title="Confirm Delete"
        body="Are you sure you want to delete these lists?"
        buttonLabel="Delete Lists"
      />
    </>
  );
};

export default ListIndexController;
